import { ref } from "../../../types/_types";

import { DistributionChannel } from "./DistributionChannel";

export const DistributionChannelRef = ref(DistributionChannel, {
	name: true,
});
